export const EMAIL_SUBSCRIPTION_FORM = 'emailSubscription';
